import { Link } from 'react-router-dom'

type LogoProps = {
  light?: boolean
  compact?: boolean
}

export function Logo({ light = false, compact = false }: LogoProps) {
  return (
    <Link
      to="/"
      className={`logo ${light ? 'logo--light' : ''} ${compact ? 'logo--compact' : ''}`}
      aria-label="BlackRock Developers home"
    >
      <img
        className="logo__asset"
        src="/images/blackrock-logo-transparent.png"
        alt=""
        aria-hidden="true"
      />
    </Link>
  )
}
